import React from 'react'

export const PositiveIcon = () => {
	return (
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0 9C0 4.038 4.03725 0 9 0C13.962 0 18 4.038 18 9C18 13.962 13.962 18 9 18C4.03725 18 0 13.962 0 9ZM7.38075 11.8995L13.0057 6.6495C13.1572 6.50775 13.1655 6.27075 13.0238 6.1185C12.8827 5.96775 12.645 5.96025 12.4943 6.10125L7.134 11.1038L5.5155 9.48525C5.3685 9.33825 5.1315 9.33825 4.98525 9.48525C4.83825 9.6315 4.83825 9.8685 4.98525 10.0155L6.86025 11.8905C6.933 11.9632 7.029 12 7.125 12C7.2165 12 7.30875 11.9662 7.38075 11.8995Z"
				fill="#88BC76"
			/>
		</svg>
	)
}
